import React from 'react';
import { Card } from "react-bootstrap";
import face_balint_kovari from "../../assets/img/face_balint_kovari.png";
import ShowMoreText from "react-show-more-text";
import proj_2d_object_detection_orientation_info from "../../assets/img/proj_2d_object_detection_orientation_info.png";

const Balint_Kovari_2d_objects = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_2d_object_detection_orientation_info} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_balint_kovari}
              /* ez a szöveg lesz majd a banneren */
              alt="Investigation of the solutions of 2D object detection models for orientation information"
            />{" "}
            <p className="text7">Bálint Kővári</p>
            <br />
            <p className="text8">
              Team Leader{" "}
            </p>
            <p className="text8">Asura Technologies </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            The realm of 2D object detection models has developed dynamically 
            in recent decades. After initial approaches such as FRCNN, more 
            widely recognized one-stage detectors such as SSD and various versions 
            of YOLO became popular. Determining objects' exact position and 
            orientation is of prime importance in applications where the spatial 
            location and orientation of objects play a critical role. During the 
            development of the topic, we emphasize networks specialized for 
            detecting objects with orientation, and we examine their effectiveness 
            against more traditional detectors. The study aims to advance the field 
            of two-dimensional object detection, mainly focusing on orientation-related challenges.
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Balint_Kovari_2d_objects;